import {useEffect} from "react";

const options = {
    root: null,
    rootMargin: '0px 0px 20px 0px',
    threshold: 0.2,
    delay: 0
}

function useAOS(option = true) {
    useEffect(() => {
        const elements = document.querySelectorAll('[data-aos]');
        const scrollObserver = new IntersectionObserver((entries, scrollObserver) => {
            entries.forEach((entry) => {
                const animateClass = entry.target.getAttribute('data-aos')
                const delay = entry.target.getAttribute('data-aos-delay') || '000'
                const duration = entry.target.getAttribute('data-aos-duration') || '600'

                if (entry.isIntersecting) {
                    //Remove From Class
                    // const animateFrom = entry.target.getAttribute('data-aos-from')
                    // if (animateFrom) {
                    //     const arrays = animateFrom.split(' ')
                    //     if (arrays && arrays.length) arrays.forEach(ell => entry.target.classList.remove(ell))
                    // }
                    //Add To Class
                    entry.target.classList.add(animateClass || 'fade-down')
                    if (delay !== '000') entry.target.style.animationDelay = delay + 'ms'
                    if (duration !== '000') entry.target.style.animationDuration = duration + 'ms'
                    scrollObserver.unobserve(entry.target)
                } else {
                    if (!option.once) entry.target.classList.remove(animateClass)
                }
            })
        }, options)
        // const elements = document.querySelectorAll('.aos')
        // elements.forEach((el) => scrollObserver.observe(el))
        Array.from(elements).forEach((el) => {
            const animateFrom = el.getAttribute('data-aos-from')
            if (animateFrom) {
                const arrays = animateFrom.split(' ')
                if (arrays && arrays.length) arrays.forEach(ell => el.classList.add(ell))
            }
            scrollObserver.observe(el)
        })
        return () => Array.from(elements).forEach((el) => scrollObserver.unobserve(el))
    }, [option])
}

export default useAOS;
